export default __webpack_public_path__ + "static/media/nsw-logo.4b520627.png";